import { clsx } from 'clsx';
import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function DiscountIcon() {
  return (
    <div className={clsx(styles['container'], styles['sale'])}>
      <img src={PROMO_ICON.get('discount')} className={styles['icon-img']} />
    </div>
  );
}
